import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import { useAuth } from './auth';

export type LimitsResponse = {
  status: string;
  resetsAt: number | null;
  rateLimitType: string;
  isUsingOverage: boolean;

  userUsed: number;
  userCap: number | null;
  userPercent: number | null;

  showGlobal: boolean;
  globalUsed: number | null;
  globalCap: number | null;
  globalPercent: number | null;
};

export const LIMITS_KEY = ['limits'] as const;

/**
 * Single source of truth for the rate-limit / quota pill. Every
 * ChatHeader subscribes to this query, so all open chats show the
 * same numbers. Polls every 15 s as a safety net; the WS
 * `rate_limit` event invalidates the query for instant updates.
 */
export function useLimits() {
  const { user } = useAuth();
  return useQuery({
    queryKey: [...LIMITS_KEY, user?.id] as const,
    enabled: user != null,
    queryFn: async () => api<LimitsResponse>('/limits'),
    refetchInterval: 15_000,
    staleTime: 5_000,
  });
}
